import React from 'react';
import SbEditable from 'storyblok-react';
import Image from '~/components/Dynamic/Image';
import TextCard from '~/components/Dynamic/TextCard';
import { motion, AnimatePresence } from 'framer-motion';

export default function LogoStrip({ blok }) {
  return (
    <SbEditable content={blok} key={blok._uid}>
      <section className={`${blok.className || ''}`}>
        <div className={`container`}>
          {blok.textCard?.length > 0 && <TextCard blok={blok.textCard[0]} />}

          <div className="flex flex-wrap lg:flex-nowrap items-center justify-center md:-ml-3 mt-8">
            {blok.logos?.map((logo, i) => (
              <div
                key={`logo${i}`}
                className="flex w-1/2 md:w-auto items-center justify-center md:pl-3 mb-4 md:mb-0  md:max-w-[12rem]"
              >
                <AnimatePresence>
                  <motion.div
                    className="mx-auto"
                    initial={{ y: 2, opacity: 0 }}
                    animate={{ y: 0, opacity: 1, transition: { delay: (i + 0.2 /* 200ms start delay */) / 7 } }}
                  >
                    <Image blok={logo} imageClassName="mx-auto" />
                  </motion.div>
                </AnimatePresence>
              </div>
            ))}
          </div>
        </div>
      </section>
    </SbEditable>
  );
}
